import { Descendant } from "slate"

// Simple slatevalue routine
export const getSlateValueFromText = (text: string): Descendant[] => {
  console.log(text)
  const breaked = text.split("\n")
  return breaked.map((para: string) => ({ type: "paragraph", children: [{ text: para }] }))
}
